import qs from "qs";

import BaseApiClient from "./BaseApiClient";
import { AxiosResponse } from "axios";

export default class Applications extends BaseApiClient {
  constructor() {
    super("v1/applications");
  }

  create(data: any = {}) {
    return this.axiosInstance({
      url: "/",
      method: "post",
      data: data,
    });
  }

  read(applicationId: string) {
    return this.axiosInstance({
      url: `/${applicationId}`,
      method: "get",
    });
  }

  update(applicationId: string, tags: any[]) {
    return this.axiosInstance({
      url: `/${applicationId}`,
      method: "put",
      data: { tags },
    });
  }

  remove(applicationId: string) {
    return this.axiosInstance({
      url: `/${applicationId}`,
      method: "delete",
    });
  }

  search(queryStrings: any = {}) {
    return this.axiosInstance({
      url: "/",
      method: "get",
      params: queryStrings,
      paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }

  /* ----------------------------------------------- APPLICATION STEPS ------------------------------------------------ */
  async searchSteps(applicationId: string, queryStrings: any = {}) {
    return this.axiosInstance({
      url: `/${applicationId}/steps`,
      method: "get",
      params: queryStrings,
    });
  }

  async saveStepData(applicationId: string, applicationStepId: string, data: any = {}) {
    return this.axiosInstance({
      url: `/${applicationId}/steps/${applicationStepId}/data`,
      method: "post",
      data: data,
    });
  }

  async saveStepDataWithTags(applicationId: string, applicationStepId: string, tags: any[], data: any = {}) {
    return this.axiosInstance({
      url: `/${applicationId}/steps/${applicationStepId}`,
      method: "put",
      data: { data, tags },
    });
  }

  async readStep({ applicationId , stepId }: { applicationId: string; stepId: string; }): Promise<AxiosResponse> {
    return this.axiosInstance({
      url: `/${applicationId}/steps/${stepId}`,
      method: "get",
    });
  }

  async saveStepTags({ applicationId , stepId, data = {} }: { applicationId: string; stepId: string; data: Record<string, any> }): Promise<AxiosResponse> {
    return this.axiosInstance({
      url: `/${applicationId}/steps/${stepId}/tags`,
      method: "put",
      data: data,
    });
  }

  async readStepData(applicationId: string, applicationStepId: string) {
    return this.axiosInstance({
      url: `/${applicationId}/steps/${applicationStepId}/data`,
      method: "get",
    });
  }
}
